import { Box, Text, Price } from "flicket-ui";
export const PaymentPlanBadge = ({
  maxInstallmentCount,
  minimumOrderAmount,
  currency,
}: {
  maxInstallmentCount: number;
  minimumOrderAmount: number;
  currency: string;
}) => {
  return (
    <Box textAlign={"center"} w={"100%"} mt={3}>
      <Text variant="regular">Payment plans available</Text>
      <Text variant="small">
        Pay over {maxInstallmentCount} months.
        {minimumOrderAmount > 0 ? <> Minimum <Price price={minimumOrderAmount} currency={currency} />. </> : ' '}
        Available at checkout.
      </Text>
    </Box>
  );
};
